import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { useMonitoring } from "@/presentation/hooks/useMonitoring";
import { ErrorScreen } from "./ErrorScreen";

export function RouteErrorFallback() {
  const error = useRouteError();
  const monitoring = useMonitoring();

  useEffect(() => {
    if (error instanceof Error) {
      monitoring.captureException(error, { tags: { boundary: "route" } });
    }
  }, [error, monitoring]);

  return <ErrorScreen />;
}
